var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressActivityBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1227_2468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1227_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 15.0832C6.99774 15.0832 6.06679 14.9022 5.20713 14.5402C4.34746 14.1783 3.59846 13.6782 2.96013 13.0397C2.32168 12.4014 1.82151 11.6524 1.45963 10.7927C1.09763 9.93307 0.916626 9.00213 0.916626 7.9999C0.916626 7.00135 1.09751 6.07218 1.45929 5.2124C1.82118 4.35274 2.32046 3.60212 2.95713 2.96057C3.5939 2.31901 4.34274 1.81518 5.20363 1.44907C6.06452 1.08296 6.99663 0.899902 7.99996 0.899902V2.48324C6.46296 2.48324 5.15929 3.01807 4.08896 4.08774C3.01851 5.1574 2.48329 6.46018 2.48329 7.99607C2.48329 9.53196 3.01813 10.836 4.08779 11.9082C5.15746 12.9805 6.46024 13.5166 7.99613 13.5166C9.53202 13.5166 10.8361 12.9813 11.9083 11.9109C12.9805 10.8406 13.5166 9.5369 13.5166 7.9999H15.1C15.1 9.00324 14.9166 9.9354 14.5498 10.7964C14.1829 11.6575 13.6801 12.4067 13.0415 13.0439C12.4027 13.6812 11.6527 14.1805 10.7916 14.5416C9.93063 14.9027 9.00007 15.0832 7.99996 15.0832Z",
    fill: "#0062E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressActivityBlue);
export default __webpack_public_path__ + "static/media/progress_activity_blue.2d6d7894f12aa41c56e0dd3f3df56561.svg";
export { ForwardRef as ReactComponent };